// extracted by mini-css-extract-plugin
export default {"notice_bar":"p6OGkr91W86wHZ9DsOCp","noticeBar":"p6OGkr91W86wHZ9DsOCp","tag":"cgGLHYGSPqQhSWeRVLTl","link":"C0u4DIV9IF6FKU4PE3DW","sp":"Mb852YJ8fBpz8ByD18gw"};